export default __webpack_public_path__ + "static/media/Prevenciones.836a6db4.jpeg";